export default __webpack_public_path__ + "static/ecomm-29fa3d1040c51df4e7686664399a008c.png";